<!-- 查看详情 -->
<template>
  <div class="info" v-loading="loading">
    <back />

    <el-form :model="ruleForm" ref="ruleForm" label-width="155px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基本信息:</div>
        <div class="container">
          <div class="item">商品名称：{{ ruleForm.productName }}</div>
          <div class="item">商品条形码：{{ ruleForm.barCode }}</div>
          <div class="item">规格：{{ ruleForm.specs }}</div>
          <div class="item">厂家：{{ ruleForm.factoryName }}</div>
          <div class="item">保质期(天)：{{ ruleForm.validityPeriod }}</div>
          <div class="item">品牌：{{ ruleForm.brand }}</div>
          <div class="item">商品类目：{{ ruleForm.firstCategoryName + '/' + ruleForm.secondCategoryName }}</div>
          <div class="item">商品类型：
            <span v-if="ruleForm.productType == 1">免费领</span>
            <span v-if="ruleForm.productType == 2">优惠品</span>
            <span v-if="ruleForm.productType == 3">热销品</span>
          </div>
        </div>
        <div class="pic">
          商品图片：
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover"
              :src="(ruleForm.picList && ruleForm.picList.length > 0) ? ruleForm.picList[0] : ''"
              :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 0) ? [ruleForm.picList[0]] : []">
            </el-image></div>
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover"
              :src="(ruleForm.picList && ruleForm.picList.length > 1) ? ruleForm.picList[1] : ''"
              :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 1) ? [ruleForm.picList[1]] : []">
            </el-image></div>
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover"
              :src="(ruleForm.picList && ruleForm.picList.length > 2) ? ruleForm.picList[2] : ''"
              :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 2) ? [ruleForm.picList[2]] : []">
            </el-image></div>

        </div>
        <el-divider></el-divider>
        <div class="title">价格信息:</div>
        <div class="pic">
          <div class="price">售价(元)：{{ ruleForm.salePrice }}</div>
          <div>划线价(元)：{{ ruleForm.linePrice }}</div>
        </div>
        <div style="display: flex;margin-top: 30px; color: #707070;">
          <div>商品介绍：</div>
          <div v-html="ruleForm.introduction"></div>
        </div>
        <el-divider></el-divider>

        <div class="title">库存信息:</div>
        <el-row class="dialog_row">
          <el-col>
            <div class="g_table">
              <el-table :data="tableData" style="width: 100%" max-height="540">
                <el-table-column label="序号" width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="" label="供应商名称" min-width="120">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.supplierName">-</span>
                    <span v-if="scope.row.supplierName">{{ scope.row.supplierName }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="supplyPrice" label="进货价(元)"
                  min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="inventoryCount" label="现库存数"
                  min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="produceDate" label="生产日期"
                  min-width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="qualityDate" label="过期时间"
                  min-width="120"></el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      productId: '',
      ruleForm: {
        supplierName: '', // 供应商名称
        serialId: '', // 商品编号
        barCode: '', // 商品条形码
        factoryName: '', // 厂家
        categoryName: '', // 商品类目
        productName: '', // 商品名称
        specs: '', // 规格
        validityPeriod: '', // 保质期
        shopName: '', // 店铺名称
        enterBox: '', // 入箱数
        brand: '', // 品牌
        supplyPrice: '', // 供货价
        salePrice: '', // 售货价
        linePrice: '', // 划线价

        picUrl: "", //商品图片
        productIntroduce: "", //介绍
      },
      tableData: [],
    }
  },
  created() {
    this.productId = this.$route.query.productId;
    this.selectProductAndInventoryInfo();
  },
  methods: {
    selectProductAndInventoryInfo() {
      this.loading = true;
      this.$axios.post(this.$api.selectProductAndInventoryInfo, {
        productId: this.$route.query.productId,
        storeId: this.$store.state.userInfo.bizId,
      }).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result
          this.tableData = res.result.inventoryInfoList || []
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.$message({
          message: err.desc,
          type: "error",
        })
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.info {

  // 1.基本信息
  .form {
    margin: 30px 20px;

    .title {
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: bold;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .item {
      width: 22%;
      /* 100% / 4 = 25%，留一点空间避免浏览器计算误差 */
      margin-bottom: 30px;
      font-size: 16px;
      color: #707070;
      margin-right: 30px;
    }
  }

  .pic {
    color: #707070;
    display: flex;

    .picbox {
      margin-right: 20px;
    }

    .price {
      margin-right: 244px;
    }
  }

  .logo_pic {
    .busilicense {
      width: 180px;
      height: 120px;
      margin-right: 10px;
    }
  }

  .flex {
    display: flex;
  }

  .introduce {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid rgba(3, 16, 14, 0.1);
    min-height: 40px;
    padding: 0 10px;

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
}

// common
.dialog_row {

  // width: 850px;
  ::v-deep.el-form-item {
    margin-right: 100px;

    .el-input__inner {
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid rgba(3, 16, 14, 0.1);
    }
  }

  ::v-deep.el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }
}
</style>
